'use strict'

import axios from 'axios'
import qs from 'qs'
import store from '../vuex/store'
import utils from './utils'
import vue from 'vue'
import router from '../router'
import authConfig from '../../src/dev-variable/auth-config'

const getIsNewRouterItem = function() {
  const authConfigData = authConfig
  const productName = sessionStorage.getItem('productName')
  const isNewRouterItem = authConfigData.filter(val => val.productCode === productName)
  return isNewRouterItem
}

axios.interceptors.request.use(
  config => {
    // loading
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

function checkStatus(response, noApi) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400 ||
      response.status === 500)
  ) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    if (!!noApi) {
      // 加载路由配置json文件
      return response.data
    } else {
      if (response.data.success === 'Success') {
        return response.data
      } else {
        // 全局接口返回提示信息
        store.commit('setGlobalAlertStatus', true)
        const errors = response => {
          const err = response.data && response.data.meta && response.data.meta.errors

          const isArray = Object.prototype.toString.call(errors) === '[object Array]'
          const isString = Object.prototype.toString.call(errors) === '[object String]'

          if (isArray) {
            return JSON.stringify(response.data.meta.errors)
          } else if (isString) {
            return response.data.meta.errors
          } else {
            return ''
          }
        }

        const message =
          response && response.data && response.data.meta && response.data.meta.message
        store.commit('setGlobalAlertText', message + '\n\n' + errors(response))
        return response.data
      }
    }
  }
  // 未授权
  if (response && response.status === 401) {
    // token失效处理 adrress是40901
    if (response.data.meta.code === 40901) {
      // token过期
      utils.clearAllLocalStorage()
      store.commit('setGlobalAlertStatus', true)
      store.commit('setGlobalAlertText', '登录认证失效，请重新登陆')
      setTimeout(function() {
        router.push('/autoLogin')
      }, 500)
      return {
        status: -404,
        msg: 'token失效'
      }
    }
    // token失效处理 纪委系统是40401
    if (response.data.meta.code === 40401) {
      // token过期
      utils.clearAllLocalStorage()
      store.commit('setGlobalAlertStatus', true)
      store.commit('setGlobalAlertText', '登录认证失效，请重新登陆')
      // setTimeout(function () {
      //   router.push('/')
      // }, 500)
      return {
        status: -404,
        msg: 'token失效'
      }
    }
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

// function checkCode (res, noApi) {
//   // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
//   if (res.status === -404) {
//     console.log(res.msg)
//   }
//   if (res.data && !res.data.success && !noApi) {
//     // console.log(res.data.error_msg)
//   }
//   return res
// }

const headers = function() {
  // 请求接口响应时间加载loading
  store.commit('updateLoadingStatus', { isLoading: true })
  const productName = sessionStorage.getItem('productName')
  let loginInfo = utils.getLocalStorage(productName)
  let token = !!loginInfo ? loginInfo.apiToken : ''
  let authorizationToken = !!loginInfo ? loginInfo.token_type + ' ' + loginInfo.access_token : ''
  const isNewRouterItem = getIsNewRouterItem()
  const authorization = !!authorizationToken
    ? authorizationToken
    : isNewRouterItem.length > 0
    ? isNewRouterItem[0].authorization
    : ''

  return {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    UUID: !!store.state.userId.length ? store.state.userId : '',
    apiToken: token,
    Authorization: authorization
  }
}

export default {
  post(url, data, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    // 区分token请求和业务请求
    return axios({
      method: 'post',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  },
  postFile(url, data, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    // 区分token请求和业务请求
    return axios({
      method: 'post',
      url,
      data: data,
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  },
  get(url, params, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  },
  put(url, data, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    // 区分token请求和业务请求
    return axios({
      method: 'put',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  },
  patch(url, data, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    // 区分token请求和业务请求
    return axios({
      method: 'patch',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  },
  delete(url, params, noApi) {
    if (vue.prototype.$debug) console.log('Api url ---->', url)
    return axios({
      method: 'delete',
      url,
      params, // get 请求时带的参数
      timeout: 30000,
      headers: headers()
    }).then(response => {
      // 加载完毕移除loading
      store.commit('updateLoadingStatus', { isLoading: false })
      return checkStatus(response, noApi)
    })
  }
}



// WEBPACK FOOTER //
// ./src/tools/http.js